import { fork, takeEvery, all } from 'redux-saga/effects';
import config from '../../../config/config';
import {
  LogControllerDtoNftStoredPowersLogListRequest,
  PerplayLogApi,
} from '../../models/src';
import { STORED_POWER_LOG_LIST_REQUEST } from '../../constants/log/storedPowerLogConstants';
import { getErrorMessage } from '../../../utils/serverErrorCheck';
import LogControllerDtoNftStoredPowersLogListResponse
  from '../../models/src/model/LogControllerDtoNftStoredPowersLogListResponse';

const api = new PerplayLogApi(config.API_CLIENT);

function* storedPowerLogListRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new LogControllerDtoNftStoredPowersLogListRequest();
    requestData.page = payload.page;
    requestData.pageLength = payload.pageLength;
    requestData.beginDate = payload.beginDate;
    requestData.endDate = payload.endDate;
    requestData.accountNo = payload.accountNo;
    requestData.nftUid = payload.nftUid;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayLogNftStoredPowersLogListPost({ logControllerDtoNftStoredPowersLogListRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, LogControllerDtoNftStoredPowersLogListResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }
    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* storedPowerLogRootSaga() {
  yield all([
    takeEvery(STORED_POWER_LOG_LIST_REQUEST, storedPowerLogListRequestSaga),
  ])
}

const storedPowerLogSaga = [
  fork(storedPowerLogRootSaga),
];

export default storedPowerLogSaga;
